import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';

import { Button } from '../../../../components';
import { Upload } from '../../../../components/Icons';
import { File } from '../File';

import {
  Title,
  Container,
  Dropzone,
  InfoText,
  Example,
  DropzoneWrapper,
  FilesWrapper,
  Files,
  FilesTitle,
  Footer,
} from './SpreadsheetStyles';

type Props = {};

export const Spreadsheet: React.FC<Props> = () => {
  const [files, setFiles] = useState<any>([]);
  const onDrop = useCallback(
    (acceptedFiles: any) => {
      setFiles([...acceptedFiles, ...files]);
    },
    [files]
  );

  const { getRootProps, getInputProps, isDragReject } = useDropzone({
    onDrop,
    accept: 'text/xlsx, text/xls, text/csv',
    maxSize: 5000000,
  });

  return (
    <Container>
      <DropzoneWrapper>
        <Dropzone {...getRootProps()}>
          <input {...getInputProps()} />
          {!isDragReject ? (
            <>
              <Title>
                <Upload size={'45px'} fill={'#0076C0'} />
                <span>Add file</span> or drop files here
              </Title>
              <InfoText>(Format: .xlxs, .csv | Max file size: 5MB)</InfoText>
            </>
          ) : (
            isDragReject && <InfoText>Some files will be rejected</InfoText>
          )}
        </Dropzone>
        <Example>
          Need help formatting your file?{' '}
          <a href='/' download>
            Download Template
          </a>
        </Example>
      </DropzoneWrapper>
      <FilesWrapper>
        <Files>
          <FilesTitle>Files to Upload</FilesTitle>
          <File status='success' />
          <File status='failed' />
          <File status='failed' />
        </Files>
      </FilesWrapper>
      <Footer>
        <Button variant={'secondary'}>Cancel</Button>
        <Button>Upload</Button>
      </Footer>
    </Container>
  );
};
